import React, { useEffect } from "react";
import RiotIcon from "../../../../assets/icons/riot.svg?react";
import { useSnapshot } from "valtio";
import { authState } from "@shared/states/authState";
import { updateRSOToken, useRSOToken } from "@shared/states/rsoState";

const BASE_URL = import.meta.env.VITE_API_URL;

interface RiotLoginButtonProps {}

const RiotLoginButton: React.FC<RiotLoginButtonProps> = (props) => {
	const rso = useRSOToken();
	const authSnap = useSnapshot(authState);

	const handleLoginClick = () => {
		window.open(
			`${BASE_URL}/rso/auth?state=${authSnap.accessToken}`,
			"RIOT ID Login",
			"width=600,height=600",
		);
	};

	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			if (event.data.type === "auth_complete") {
				updateRSOToken();
			}
		};

		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	}, []);

	if (rso.loading) {
		return (
			<div
				className={
					"flex items-center p-1 rounded border border-red-950 bg-[#EB0029] text-white gap-2"
				}
			>
				Loading...
			</div>
		);
	}

	return (
		<a
			className={
				"flex items-center p-1 rounded border border-red-950 bg-[#EB0029] text-white gap-2 hover:brightness-105 cursor-pointer"
			}
			target={"_"}
			href={`${BASE_URL}/rso/auth?state=${authSnap.accessToken}`}
		>
			<RiotIcon width={20} />
			Connect RIOT ID
		</a>
	);
};

export { RiotLoginButton };
